import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
const selectAllErrors = state => state.form.errors;
const WatchErrors = props => {
    const { onChange } = props;
    const errors = useSelector(selectAllErrors);
    useEffect(() => {
        onChange && onChange(errors);
    }, [onChange, errors]);
    return null;
};
WatchErrors.propTypes = {
    onChange: PropTypes.func.isRequired,
};
export default WatchErrors;
